import { render } from "./menu-button.vue?vue&type=template&id=084769f2&scoped=true"
import script from "./menu-button.vue?vue&type=script&lang=js"
export * from "./menu-button.vue?vue&type=script&lang=js"

import "./menu-button.vue?vue&type=style&index=0&id=084769f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084769f2"]])

export default __exports__